import React from 'react'
import { Box } from '@mui/material'
import {
  EmptyScreenMainBox,
  EmptyScreenSecondaryTypography,
  EmptyScreenTitleTypography,
} from './styled/EmptyScreen.styled'

interface EmptyScreenProps {
  containerHeight: string
  mainText: string
  secondaryText?: string
  children?: React.ReactNode
}

// Generic "nothing here yet" state — swap in domain-specific copy/children per page rather than
// forking this component.
const EmptyScreen: React.FC<EmptyScreenProps> = ({
  containerHeight,
  mainText,
  secondaryText,
  children,
}) => {
  return (
    <EmptyScreenMainBox height={containerHeight}>
      <Box width="100%" textAlign="center">
        <EmptyScreenTitleTypography variant="h5">{mainText}</EmptyScreenTitleTypography>
        {secondaryText && (
          <EmptyScreenSecondaryTypography variant="subtitle1">
            {secondaryText}
          </EmptyScreenSecondaryTypography>
        )}
        {children && <Box mt={2}>{children}</Box>}
      </Box>
    </EmptyScreenMainBox>
  )
}

export default EmptyScreen
